import styled from "@emotion/styled";
import {
  createPolymorphicComponent,
  Text,
  type TextProps,
} from "@mantine/core";

export const BoxContainer = styled.div`
  min-width: 60%;
  height: 95%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const _Title = styled(Text)`
  color: white;
  text-align: center;
  font-weight: 700;
  font-size: 1.3rem;
  border-bottom: 1px solid white;
  padding-bottom: 10px;
  margin-bottom: 30px;
`;

const _BackButton = styled(Text)`
  color: #a5d8ff;
  font-size: 0.8rem;
  margin-top: 10px;
  text-decoration: underline;
  text-align: start;
  padding: 0 5px;
  width: fit-content;
  cursor: pointer;
`;

export const BackButton = createPolymorphicComponent<"text", TextProps>(
  _BackButton,
);

export const Title = createPolymorphicComponent<"text", TextProps>(_Title);
